/* Bubble Bucks on the homepage: your balance under the game window (and in the
   header), and a rewards window: wallpapers and art to download, stickers and
   keycaps to pick up at the stand, and the odd free-shipping code. Talks to the
   Bubble Bank through the store's app proxy (/apps/bubble), which knows who's
   signed in. If the bank isn't reachable, the bar stays hidden. */
(() => {
  // ---- The free topping (sign-up reward) in the homepage Bubble List card ----
  const topping = document.querySelector('[data-bbp-topping][data-signed-in]');
  if (topping) {
    const joined = new URLSearchParams(location.search).get('joined');
    if (joined) history.replaceState(null, '', location.pathname + location.hash);
    const esc = (v) => String(v).replace(/[&<>"]/g, (c) => `&#${c.charCodeAt(0)};`);
    const draw = (st) => {
      const t = st?.topping;
      if (!t) return;
      topping.innerHTML = t.used
        ? `<p class="bbp-topping-card is-used"><b>Free topping: enjoyed!</b><small>Thanks for being in the bubble.</small></p>`
        : `<div class="bbp-topping-card">${joined ? '<p class="bbp-topping-hi"><b>Welcome to the bubble!</b></p>' : ''}<p><b>Your free topping</b><small>${esc(t.note)}. Show this code at the stand, then tap the button in front of us.</small></p><p class="bbp-reward-code">${esc(t.code)}</p><button type="button" class="bb-button bb-button--pink" data-topping-use>Picked up</button></div>`;
      topping.querySelector('[data-topping-use]')?.addEventListener('click', async (e) => {
        const b = e.currentTarget;
        // Two taps, so it isn't used up by accident.
        if (b.dataset.sure !== '1') {
          b.dataset.sure = '1';
          b.textContent = 'Tap again at the stand';
          return;
        }
        b.disabled = true;
        const res = await fetch('/apps/bubble/pickup', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: t.code }) })
          .then((r) => r.json())
          .catch(() => null);
        if (res?.ok) {
          const at = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
          topping.innerHTML = `<p class="bbp-topping-card bbp-picked"><b>Free topping ✓</b><small>Used at ${at}. Enjoy!</small></p>`;
        } else draw(res?.topping ? res : st);
      });
    };
    fetch('/apps/bubble/balance')
      .then((r) => ((r.headers.get('content-type') || '').includes('json') ? r.json() : null))
      .then(draw)
      .catch(() => {});
    if (joined) topping.closest('section')?.scrollIntoView({ block: 'center' });
  }

  const bar = document.querySelector('[data-bbp-bucks]');
  const dialog = document.querySelector('[data-bucks-dialog]');
  const meCount = document.querySelector('[data-bbp-me-n]');
  if (!bar || !dialog) {
    // Pages without the arcade: just keep the header balance up to date for signed-in players.
    if (meCount)
      fetch('/apps/bubble/balance')
        .then((r) => ((r.headers.get('content-type') || '').includes('json') ? r.json() : null))
        .then((st) => st?.signedIn && st.bucks !== false && (meCount.textContent = Number(st.balance || 0).toLocaleString('en-US')))
        .catch(() => {});
    return;
  }
  const $ = (sel, root = bar) => root.querySelector(sel);
  const line = $('[data-bucks-line]');
  const login = $('[data-bucks-login]');
  const open = $('[data-bucks-open]');
  const balanceEl = $('[data-bucks-balance]', dialog);
  const list = $('[data-bucks-rewards]', dialog);
  const got = $('[data-bucks-got]', dialog);
  const mine = $('[data-bucks-mine]', dialog);
  let files = {};
  try {
    files = JSON.parse($('[data-bucks-files]', dialog)?.textContent || '{}');
  } catch {}
  const n = (v) => Number(v || 0).toLocaleString('en-US');
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => `&#${c.charCodeAt(0)};`);
  let state = null;
  let notice = '';

  // Back from scanning the stand's QR code?
  const checkin = new URLSearchParams(location.search).get('checkin');
  if (checkin) {
    notice =
      {
        ok: '<b>+100 Bubble Bucks</b> for visiting the stand!',
        again: 'You already checked in at the stand today. See you next time!',
        closed: 'Check-ins count while the stand is open (weekends at the SEA Market). Come say hi!',
        expired: 'Scan the QR code at the stand to check in.',
      }[checkin] || '';
    history.replaceState(null, '', location.pathname + location.hash);
  }

  const call = async (path, body) => {
    const res = await fetch(`/apps/bubble/${path}`, body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {});
    if (!(res.headers.get('content-type') || '').includes('json')) throw new Error('bank unavailable');
    return res.json();
  };

  const downloads = (id) =>
    (files[id] || []).map((f) => `<a class="bb-button" href="${esc(f.url)}" download target="_blank" rel="noopener">${esc(f.name)}</a>`).join('');

  const showGot = (html) => {
    got.hidden = false;
    got.innerHTML = html;
    got.querySelector('[data-copy]')?.addEventListener('click', (e) => {
      navigator.clipboard?.writeText(e.target.dataset.copy).then(() => (e.target.textContent = 'Copied!'), () => {});
    });
  };

  const render = () => {
    if (!state) return;
    // Bubble Bucks paused (games are just for fun): no bar, no balance.
    if (state.signedIn && state.bucks === false) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    if (!state.signedIn) {
      login.hidden = false;
      open.hidden = true;
      // Check-ins need an account, so guests only see the expired-code note.
      if (checkin === 'expired' || checkin === 'closed') line.innerHTML = notice;
      return;
    }
    login.hidden = true;
    open.hidden = false;
    if (meCount) meCount.textContent = n(state.balance);
    const welcome = state.welcome > 0 ? '<b>Welcome! +100 Bubble Bucks</b> for signing up. ' : '';
    line.innerHTML = notice || welcome ? `${notice || welcome} You have <b>${n(state.balance)}</b>.` : `You have <b>${n(state.balance)} Bubble Bucks</b>. Rewards start at 100.`;
    balanceEl.textContent = `${n(state.balance)} bucks`;
    list.innerHTML = '';
    for (const r of state.rewards || []) {
      const li = document.createElement('li');
      li.innerHTML = `<span><b>${esc(r.title)}</b><small>${n(r.cost)} bucks · ${esc(r.note)}</small></span>`;
      const btn = document.createElement('button');
      btn.type = 'button';
      if (r.owned) {
        btn.className = 'bb-button';
        btn.textContent = 'Download';
        btn.addEventListener('click', () => showGot(`<p>Tap one to open it, then save it to your phone.</p><div class="bbp-reward-actions">${downloads(r.id)}</div>`));
      } else {
        btn.className = 'bb-button' + (r.ready ? ' bb-button--pink' : '');
        btn.disabled = !r.ready;
        btn.textContent = r.ready ? (r.kind === 'digital' ? 'Unlock' : 'Get code') : r.limited ? 'Next month' : `${n(Math.max(0, r.cost - state.balance))} to go`;
        btn.addEventListener('click', () => redeem(r, btn));
      }
      li.append(btn);
      list.append(li);
    }
    // Codes waiting to be used: pickups at the stand, shipping codes at checkout.
    const waiting = state.codes || [];
    mine.hidden = !waiting.length;
    mine.innerHTML = waiting.length
      ? `<p class="bbp-reward-kicker">Your codes</p>${waiting
          .map((c) =>
            c.kind === 'pickup'
              ? `<p><b class="bbp-bucks-code">${esc(c.code)}</b> ${esc(c.title)}<small>At the stand: show this, then tap “Picked up” in front of us.</small><button type="button" class="bb-button" data-picked="${esc(c.code)}">Picked up</button></p>`
              : `<p><b class="bbp-bucks-code">${esc(c.code)}</b> ${esc(c.title)}<small>Use at checkout</small></p>`,
          )
          .join('')}`
      : '';
    mine.querySelectorAll('[data-picked]').forEach((b) =>
      b.addEventListener('click', async () => {
        // Two taps, so it isn't spent by accident.
        if (b.dataset.sure !== '1') {
          b.dataset.sure = '1';
          b.textContent = 'Tap again to confirm';
          return;
        }
        b.disabled = true;
        try {
          const res = await call('pickup', { code: b.dataset.picked });
          const at = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
          showGot(res.ok ? `<p class="bbp-picked"><b>Picked up ✓</b> ${esc(b.dataset.picked)} at ${at}. Enjoy!</p>` : 'That code was already picked up.');
          if (res.signedIn) state = { ...res, welcome: 0 };
          render();
        } catch {
          b.disabled = false;
          b.textContent = 'Try again';
        }
      }),
    );
  };

  const redeem = async (r, btn) => {
    btn.disabled = true;
    btn.textContent = 'One sec…';
    try {
      const res = await call('redeem', { reward: r.id });
      if (res.kind === 'digital') {
        showGot(`<p><b>Unlocked: ${esc(res.title)}!</b> Tap one to open it, then save it to your phone.</p><div class="bbp-reward-actions">${downloads(r.id)}</div>`);
        window.bbpFizz?.jingle?.();
      } else if (res.code) {
        const how = res.kind === 'pickup' ? 'Show this code at the stand and we’ll hand it over.' : `Use it at checkout on merch within ${res.days} days.`;
        showGot(`<p>${esc(res.title)}:</p><p class="bbp-reward-code">${esc(res.code)}</p><p>${how}</p>${res.kind === 'shipping' ? `<button type="button" class="bb-button" data-copy="${esc(res.code)}">Copy code</button>` : ''}`);
        window.bbpFizz?.jingle?.();
      } else {
        showGot(res.error ? `Hmm: ${esc(res.error)}.` : 'That didn’t work. Your bucks are safe.');
      }
      if (res.signedIn) state = { ...res, welcome: 0 };
    } catch {
      showGot('The bank is napping. Try again in a minute; your bucks are safe.');
    }
    render();
  };

  const refresh = async () => {
    try {
      state = await call('balance');
      render();
    } catch {
      bar.hidden = true;
    }
  };

  open.addEventListener('click', async () => {
    got.hidden = true;
    await refresh();
    dialog.showModal();
  });
  $('[data-bucks-close]', dialog).addEventListener('click', () => dialog.close());
  // Other "See my rewards" buttons on the page open the same window.
  document.querySelectorAll('[data-bucks-open-any]').forEach((b) => b.addEventListener('click', () => (state?.signedIn ? open.click() : login.click())));
  if (location.hash === '#rewards') addEventListener('load', () => setTimeout(() => state?.signedIn && open.click(), 600));
  // "Play Bubbleworld" in the window: close it, the page's Play handler starts the game.
  $('[data-bucks-play]', dialog)?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (e) => e.target === dialog && dialog.close());
  // The game banks as you play: catch up when you pause or come back to the tab.
  window.addEventListener('bubbleworld:pause', refresh);
  document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && refresh());
  // Ask the bank right away after a stand check-in or when signed in (the header shows
  // your balance); otherwise wait until the Play section is near.
  if (checkin || meCount || location.hash === '#rewards') refresh();
  else if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (es) => {
        if (es.some((e) => e.isIntersecting)) {
          io.disconnect();
          refresh();
        }
      },
      { rootMargin: '300px 0px' },
    );
    io.observe(bar.closest('section') || bar);
  } else refresh();
})();
